import { Platform, StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: brand.main.variations['lighterWater-3'],
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  topContent: {
    backgroundColor: neutrals.white,
    flexDirection: 'row',
    borderRadius: 20,
    gap: 32,
    paddingVertical: 24,
    paddingHorizontal: 45,
    width: 616,
    alignItems: 'center',
    minHeight: 243,
  },
  qrCodeWrapper: {
    width: 145,
    height: 145,
    justifyContent: 'center',
    alignItems: 'center',
  },
  instructions: {
    gap: 16,
    flex: 1,
  },
  stepsTitle: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  stepsWrapper: {
    gap: 8,
  },
  step: {
    flexDirection: 'row',
    gap: 8,
  },
  stepNumber: {
    fontSize: 30,
    lineHeight: 45,
    fontWeight: 700,
    color: brand.main.water,
    width: 30,
  },
  stepTitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  stepDescription: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  connected: {
    gap: 16,
    flex: 1,
  },
  connectedIcon: {
    width: 32,
    height: 32,
  },
  textWrapper: {
    gap: 8,
  },
  connectedTitle: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  connectedDescription: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  separator: {
    borderTopWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  bottomContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  bottomText: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.smoke,
  },
  cta: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
  },
  ctaIcon: {
    width: 16,
    height: 16,
    padding: 1,
  },
  ctaText: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 700,
    color: brand.main.water,
  },
  tooltip: {
    position: 'absolute',
    top: -40,
    left: 20,
    backgroundColor: neutrals.white,
    borderRadius: 8,
    padding: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    zIndex: 100,
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
  },
  tooltipText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  tooltipIcon: {
    width: 16,
    height: 16,
  },
});
